import { render } from "./VlogHeader.vue?vue&type=template&id=0a85fe60&scoped=true"
import script from "./VlogHeader.vue?vue&type=script&lang=js"
export * from "./VlogHeader.vue?vue&type=script&lang=js"

import "./VlogHeader.vue?vue&type=style&index=0&id=0a85fe60&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85fe60"]])

export default __exports__